<template>
	<div class="m-portlet m-portlet--brand betted-ratio">
		<div class="m-portlet__head row">
			<div v-if="user.code.length == 0" class="col-12 col-sm-2">
				<div class="input-group">
					<select class="form-control filterHouseSelection">
					</select>
				</div>
			</div>
			<div v-if="user.code.length <= 1" class="col-12 col-sm-2">
				<div class="input-group">
					<select class="form-control filterCompanySelection">
					</select>
				</div>
			</div>
			<div v-if="user.code.length <= 3" class="col-12 col-sm-3">
				<div class="input-group">
					<select class="form-control filterGeneralSelection">
					</select>
				</div>
			</div>
			<div v-if="user.code.length <= 5" class="col-12 col-sm-3">
				<div class="input-group">
					<select class="form-control filterAgencySelection">
					</select>
				</div>
			</div>
			<div class="col-12 col-sm-2">
				<button @click="viewReport" type="button" class="btn btn-brand m-btn m-btn--custom">Xem</button>
			</div>
		</div>
		<div class="m-portlet__body">
			<!--begin::Section-->
			<div class="m-section">
				<div class="m-section__content">
					<div id="chartContainer"></div>
				</div>
			</div>
			<!--end::Section-->
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	import { mapGetters } from 'vuex';
	import Highcharts from 'highcharts';

	export default {
		data(){
	        return {
	        	"houseFilter": [],
	        	"companyFilter": [],
	        	"generalFilter": [],
	        	"agencyFilter": [],
	        	"chartData": []
	        }
	    },

	    watch: {
	    	houseFilter: function(val){
	    		this.initSelect2(".filterHouseSelection", val);
	    	},
	    	companyFilter: function(val){
	    		this.initSelect2(".filterCompanySelection", val);
	    	},
	    	generalFilter: function(val){
	    		this.initSelect2(".filterGeneralSelection", val);
	    	},
	    	agencyFilter: function(val){
	    		this.initSelect2(".filterAgencySelection", val);
	    	},
	    	chartData: function(val){
	    		let cats = val.map(e => (e.code));
	    		let trial = val.map(e => (e.totalTrial));
	    		let paid = val.map(e => (e.totalPaid));

	    		Highcharts.chart('chartContainer', {
				    chart: {
				        type: 'column'
				    },
				    title: {
				        text: 'Số lượng player dùng thử / số lượng player thực'
				    },
				    subtitle: {
				        text: ''
				    },
				    xAxis: {
				        categories: cats,
				        crosshair: true
				    },
				    yAxis: {
				        min: 0,
				        title: {
				            text: 'Số player'
				        }
				    },
				    tooltip: {
				        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
				        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
				            '<td style="padding:0"><b>{point.y}</b></td></tr>',
				        footerFormat: '</table>',
				        shared: true,
				        useHTML: true
				    },
				    plotOptions: {
				        column: {
				            pointPadding: 0.2,
				            borderWidth: 0
				        },
				        series: {
				            dataLabels: {
				                enabled: true
				            }
				        }
				    },
				    series: [{
				        name: 'Trial player',
				        data: trial

				    }, {
				        name: 'Paid player',
				        data: paid

				    }]
				});
	    	}
	    },

        mounted(){
        	this.fetchChilds(this.user.code);
        },

    	computed: {
			...mapGetters({
				user: 'user',
		  		gameInfo: 'gameInfo'
			})
		},

	    methods: {
	        initSelect2: function(selector, data){
	        	let vm = this;

	    		if ($(selector).hasClass("select2-hidden-accessible")) {
				    $(selector).select2('destroy');
				}
				$(selector).off("change.select2");
				$(selector).html("");
	    		
	    		let xdata = [...data];
	    		xdata.unshift({ id: "_",  text: "-- Chọn user" });
	    		$(selector).select2({data: xdata, width:"100%"});
	    		$(selector).on("change.select2", function(e){
					let code = $(this).val();

					if(code == "_"){
						const selectorArr = [".filterCompanySelection", ".filterGeneralSelection", ".filterAgencySelection"];
						let f = selectorArr.indexOf(selector);
						if((f+1) == selectorArr.length) return;
						for(let i=f+1;i<selectorArr.length;i++){
							$(selectorArr[i]).val("_").trigger('change');
						}
						return;
					}

					vm.fetchChilds(code);
				});
	        },
	        fetchChilds: async function(code){
	        	if(code.length >= 7) return;
	        	let childs = await axios.get(`admin-panel/user/getFirstChilds/${code}`);
	        	let data = childs.data.data.map(e => ({id: e.code, text: e.code}));

	        	switch(code.length){
	        		case 0: this.houseFilter = data; break;
	        		case 1: this.companyFilter = data; break;
	        		case 3: this.generalFilter = data; break;
	        		case 5: this.agencyFilter = data; break;
	        	}
	        },
	        viewReport: async function(){
	        	let house = $(".filterHouseSelection").val();
	        	let company = $(".filterCompanySelection").val();
	        	let general = $(".filterGeneralSelection").val();
	        	let agency = $(".filterAgencySelection").val();

	        	let code = agency;
	        	if(code == "_" || code == null) code = general;
	        	if(code == "_" || code == null) code = company;
	        	if(code == "_" || code == null) code = house;
	        	if(code == "_" || code == null){
	        		code = this.user.code;
	        	}

	        	let res = await axios.get(`admin-panel/tools/analysis-customer/${code}`);
	        	this.chartData = res.data.data;
	        }
	    }
	}

</script>
<style>
	.betted-ratio .m-portlet__head.row{
		padding: 0;
		padding-top: 10px;
	}
</style>